







































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component

export default class AListCustomItem extends Vue {
  @Prop({ default: null, required: false, type: [ String, Number ] }) title!: string | number | null

  @Prop({ default: null, required: false, type: [ String, Number ] }) subtitle!: string | number | null

  @Prop({ default: null, required: false, type: [ String, Number ] }) description!: string | number | null
}
